import SeleksiVendorPurchaseOrderAset from './SeleksiVendorPurchaseOrderAset';

export default SeleksiVendorPurchaseOrderAset;
